import { FC, Fragment } from "react";
import { Typography } from "@mui/material";
import NoFilteredData from "@/assets/feedback-icons/no-filtered-data.png";

export const InfrastructureArchitectureDiagramEmpty: FC = () => {
  return (
    <Fragment>
      <img src={NoFilteredData} alt="No matching results found" width={140} />

      <Typography variant="h6" fontWeight="normal">
        No matching results found. Please adjust filters.{" "}
      </Typography>
    </Fragment>
  );
};
